import React from "react";
import { Box, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import CustomTypography from "components/common/CustomTypography";
import { useNavigate } from "react-router-dom";
import program_start from "static/image/onboarding/program_start.svg";
import { BottomNextButton } from "../../../../components/common/BottomNextButton";
import { userAtom } from "../../../../recoil/userAtom";
import { useRecoilState } from "recoil";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { programSetupApi } from "../../../../api/programSetupApi";
import useClose from "../../../../hooks/useClose";
import { USER_DETAIL_ENDPOINT, USER_DOMAIN } from "../../../../api/userApi";

export default function Introduction_6() {
  const [user, setUser] = useRecoilState(userAtom);
  const navigate = useNavigate();
  const close = useClose();

  const queryClient = useQueryClient();

  const { mutate: start, isLoading } = useMutation(
    () => programSetupApi.start(),
    {
      onSuccess: async () => {
        setUser((prevUser) => ({
          ...prevUser,
          isOnboardingRequired: false,
        }));

        queryClient.invalidateQueries([
          USER_DOMAIN,
          USER_DETAIL_ENDPOINT,
          user?.userId,
        ]);

        close();
      },
    }
  );

  const handleNext = () => {
    if (user?.onboardingType === "g") {
      start();
    } else if (user?.paymentPageType === "m") {
      navigate("/onboarding_new/payment/1", { replace: true });
    } else {
      navigate("/onboarding_new/product/1", { replace: true });
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "70vh" }}>
      <Stack
        sx={{
          height: "100%",
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Stack spacing={2}>
          <CustomTypography
            variant="Subtitle"
            fontWeight={700}
            sx={{
              color: theme.vars.palette.Content.Highlight,
            }}
          >
            {"과학이 만드는 변화를 지금 시작하세요."}
          </CustomTypography>
          <CustomTypography
            variant="Subtitle"
            fontWeight={500}
            sx={{
              color: theme.vars.palette.Content.Strong,
            }}
          >
            {"디스턴싱은 현대 정신의학 이론을 집대성한 전세계 유일의 근거 기반\n" +
              "인지행동치료 프로그램입니다."}
          </CustomTypography>
        </Stack>
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: 0,
            marginTop: "70px",
          }}
        >
          <img
            src={program_start}
            alt={"onboarding"}
            style={{
              maxWidth: "100%",
              maxHeight: "80%",
              objectFit: "contain",
            }}
          />
        </Box>
      </Stack>
      <BottomNextButton
        disabled={false}
        onClick={handleNext}
        text={`${user?.onboardingType === "g" ? "프로그램 시작하기" : "다음"}`}
        highlightBackground={true}
        loading={isLoading}
      />
    </Box>
  );
}
